/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowMatchList = {
    type: 'array',
    contains: {
        type: 'UserFollowMatch',
    },
} as const;
